import React from "react";

import { CONSTRUCTOR_LINK } from "config";
import submitIcon from "static/submit.svg";

const AnswerPill = ({ id, name, index, selected, onSelect }) => (
    <label className={`answer-pill${selected ? " answer-pill--selected" : ""}`}>
        <input type="checkbox" value={id} checked={selected} onChange={() => onSelect(id, index)} />
        <span className="answer-pill__num">{index + 1}.</span>
        <span className="answer-pill__text">{name}</span>
    </label>
);

export const SelectAnswers = ({
    answers,
    question,
    confirmBtnHandler,
    changeAnswer,
    onAnswerClick,
    isConfirmPossible,
}) => {
    const hasImageAnswers = question.answers.some(({ isImage, image }) => isImage && image);
    const isMulti = question.type === "multi";
    const isColumn = question.answers.length <= 2;

    const handleClick = (id, index) => {
        if (isMulti) {
            changeAnswer(id, index);
        } else {
            onAnswerClick(id, index);
        }
    };

    return (
        <>
            {hasImageAnswers ? (
                <div className={`answers-image-grid${isColumn ? " answers-image-grid--column" : ""}`}>
                    {question.answers.map(({ id, name, isImage, image }, index) =>
                        isImage && image ? (
                            <label
                                key={id}
                                className={`answer-image-card answer-image-card--ear-${isColumn || index % 2 === 0 ? "left" : "right"}${answers[index] === id ? " answer-image-card--selected" : ""}`}
                            >
                                <input
                                    type="checkbox"
                                    value={id}
                                    checked={answers[index] === id}
                                    onChange={() => handleClick(id, index)}
                                />
                                <div className="answer-image-card__body">
                                    <img src={`${CONSTRUCTOR_LINK}/api/static/images/${image}`} alt="" />
                                </div>
                                <span className="answer-image-card__ear">{index + 1}.</span>
                            </label>
                        ) : (
                            <AnswerPill
                                key={id}
                                id={id}
                                name={name}
                                index={index}
                                selected={answers[index] === id}
                                onSelect={handleClick}
                            />
                        )
                    )}
                </div>
            ) : (
                <div className="answers-new-grid">
                    {question.answers.map(({ id, name }, index) => (
                        <AnswerPill
                            key={id}
                            id={id}
                            name={name}
                            index={index}
                            selected={answers[index] === id}
                            onSelect={handleClick}
                        />
                    ))}
                </div>
            )}

            {isMulti && (
                <div className="answers-confirm-row">
                    <button
                        className={`answers-confirm-btn${isConfirmPossible ? " answers-confirm-btn--active" : ""}`}
                        onClick={isConfirmPossible ? confirmBtnHandler : undefined}
                        disabled={!isConfirmPossible}
                    >
                        <img src={submitIcon} alt="" />
                    </button>
                </div>
            )}
        </>
    );
};
